























































import "./team-calendar.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import EventDetail from "./event-detail.vue";
import CalendarHeader from "./calendar-header.vue";
import moment from "moment-timezone";

import { CalendarView, CalendarViewHeader, CalendarMathMixin } from "vue-simple-calendar";
import "vue-simple-calendar/static/css/default.css";

let _ = require("lodash");
let parser = require("cron-parser");

export default Vue.extend({
  name: "TeamCalendar",
  components: { EventDetail, CalendarView, CalendarHeader, CalendarViewHeader },
  mixins: [CalendarMathMixin],
  props: {
    id: String,
  },
  data() {
    return {
      isLoading: false,

      version: NaN,

      showEventDetails: false,
      edittingEvent: {
        id: null,
        startDate: null,
        endDate: null,
        title: "",
        classes: null,
        url: null,
      },

      showDate: (this as any).thisMonth(1),
      message: "",
      startingDayOfWeek: 0,
      disablePast: false,
      disableFuture: false,
      displayPeriodUom: "month",
      displayPeriodCount: 1,
      displayWeekNumbers: false,
      showTimes: true,
      selectionStart: null,
      selectionEnd: null,
      useDefaultTheme: true,
      useHolidayTheme: true,
      useTodayIcons: false,
      series: [],
      items: [
        // {
        //   id: "e0",
        //   startDate: "2018-01-05",
        //   title: "e0",
        //   description: "",
        // },
        // {
        //   id: "e3",
        //   startDate: (this as any).thisMonth(7, 9, 25),
        //   endDate: (this as any).thisMonth(10, 16, 30),
        //   title: "Multi-day item with a long title and times",
        // },
        // {
        //   id: "e4",
        //   startDate: (this as any).thisMonth(20),
        //   title: "My Birthday!",
        //   classes: "birthday",
        //   url: "https://en.wikipedia.org/wiki/Birthday",
        // },
        // {
        //   id: "e5",
        //   startDate: (this as any).thisMonth(5),
        //   endDate: (this as any).thisMonth(12),
        //   title: "Multi-day item",
        //   classes: "purple",
        // },
        // {
        //   id: "e6",
        //   startDate: (this as any).thisMonth(29),
        //   title: "Same day 1",
        // },
      ],
    };
  },
  computed: {
    eventModel(): any {
      let series = this.series.map((serie) => {
        return {
          id: serie.id,
          title: serie.title,
          description: serie.description,
          recurrence: serie.recurrence,
          selectedMemberIds: serie.selectedMemberIds,
          attachments: serie.attachments,
          allDay: serie.allDay,
          startDate: serie.startDate,
          endDate: serie.endDate,
          useTimezone: serie.useTimezone,
          timezone: serie.timezone,
          timezoneAbbr: serie.timezoneAbbr,
          classes: serie.classes,
          url: serie.url,
        };
      });

      let items = this.items.map((item) => {
        return {
          id: item.id,
          serieId: item.serieId,
          title: item.title,
          description: item.description,
          recurrence: item.recurrence,
          selectedMemberIds: item.selectedMemberIds,
          attachments: item.attachments,
          allDay: item.allDay,
          startDate: item.startDate,
          endDate: item.endDate,
          useTimezone: item.useTimezone,
          timezone: item.timezone,
          timezoneAbbr: item.timezoneAbbr,
          classes: item.classes,
          url: item.url,
        };
      });

      return {
        series: series,
        items: items,
        version: this.version || 0,
      };
    },
    ...mapState("team", ["currentTeam"]),
    ...mapGetters("team", ["canEditCurrentTeam"]),
    userLocale() {
      let context = this as any;
      return context.getDefaultBrowserLocale;
    },
    dayNames() {
      let context = this as any;
      return context.getFormattedWeekdayNames(context.userLocale, "long", 0);
    },
    themeClasses() {
      let context = this as any;
      return {
        "theme-default": context.useDefaultTheme,
        "holiday-us-traditional": context.useHolidayTheme,
        "holiday-us-official": context.useHolidayTheme,
      };
    },
    myDateClasses() {
      // This was added to demonstrate the dateClasses prop. Note in particular that the
      // keys of the object are `yyyy-mm-dd` ISO date strings (not dates), and the values
      // for those keys are strings or string arrays. Keep in mind that your CSS to style these
      // may need to be fairly specific to make it override your theme's styles. See the
      // CSS at the bottom of this component to see how these are styled.
      const o = {};
      const theFirst = (this as any).thisMonth(1);
      const ides = [2, 4, 6, 9].includes(theFirst.getMonth()) ? 15 : 13;
      const idesDate = (this as any).thisMonth(ides);
      //o[this.isoYearMonthDay(idesDate)] = "ides";
      //o[this.isoYearMonthDay(this.thisMonth(21))] = ["do-you-remember", "the-21st"];
      return o;
    },
  },
  created() {},
  mounted() {
    let context = this as any;
    this.$Notice.config({
      top: 50,
      duration: 2,
    });

    //fix toLocalDate
    (this.$refs.CalendarView as any).toLocalDate = function (d: any) {
      return moment(d).toDate();
    };

    //this.loadCalendar();

    abp.event.on("abp.notifications.received", this.handleNotificationReceived);
  },
  beforeDestroy() {
    console.log("leave page");
    abp.event.off("abp.notifications.received", this.handleNotificationReceived);
  },
  watch: {
    eventModel: {
      handler: function () {
        if (this.isLoading === true) {
          return;
        }

        let currentTeam = (this as any).currentTeam;
        let originalToJson = Date.prototype.toJSON;

        Date.prototype.toJSON = function () {
          return moment(this).format();
        };
        let teamContent = {
          content: JSON.stringify(this.eventModel),
          contentVersion: currentTeam.contentVersion,
          id: currentTeam.id,
        };
        Date.prototype.toJSON = originalToJson;

        if (teamContent.content != currentTeam.content) {
          this.$store
            .dispatch("team/updateContent", { data: teamContent })
            .then((response) => {
              this.$Notice.success({
                title: "Saved",
              });
            })
            .catch((error) => {
              if (error.response.status === 403) {
                this.loadCalendar();
              }
            });
        }
      },
      deep: true,
    },
    currentTeam() {
      let context = this as any;
      context.loadCalendarData();
    },
  },
  methods: {
    loadCalendar() {
      if (this.id) {
        this.$store.dispatch("team/get", { id: this.id }).then((response) => {});
      }
    },
    loadCalendarData() {
      let context = this as any;
      let content = context.currentTeam.content;
      let calendar = { version: 0, series: [], items: [] };
      if (content !== null && content !== "") {
        calendar = JSON.parse(content);
      }

      this.isLoading = true;

      this.version = calendar.version || 0;

      this.items = calendar.items.map((event) => {
        return {
          id: event.id,
          serieId: event.serieId,
          title: event.title,
          description: event.description,
          recurrence: event.recurrence,
          selectedMemberIds: event.selectedMemberIds,
          attachments: event.attachments,
          allDay: event.allDay,
          startDate: event.startDate,
          endDate: event.endDate,
          useTimezone: event.useTimezone,
          timezone: event.timezone,
          timezoneAbbr: event.timezoneAbbr,
          classes: event.classes,
          url: event.url,
        };
      });

      this.series = calendar.series.map((event) => {
        return {
          id: event.id,
          title: event.title,
          description: event.description,
          recurrence: event.recurrence,
          selectedMemberIds: event.selectedMemberIds,
          attachments: event.attachments,
          allDay: event.allDay,
          startDate: event.startDate,
          endDate: event.endDate,
          useTimezone: event.useTimezone,
          timezone: event.timezone,
          timezoneAbbr: event.timezoneAbbr,
          classes: event.classes,
          url: event.url,
        };
      });

      setTimeout(function () {
        context.isLoading = false;
      }, 100);
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.id && userNotification.notification.data.version > (this as any).currentTeam.contentVersion) {
        this.loadCalendar();
      }
    },
    uuid() {
      // Public Domain/MIT
      var d = new Date().getTime(); //Timestamp
      var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    },
    thisMonth(d, h, m) {
      const t = new Date();
      return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0);
    },
    onClickDay(date) {
      if ((this as any).canEditCurrentTeam === true) {
        this.addNewItem(date);
      }
    },
    onClickItem(e) {
      if (e.originalItem.serieId) {
        let series = this.series.filter((serie) => serie.id === e.originalItem.serieId);
        if (series.length === 1) {
          this.edittingEvent = Object.assign({}, series[0], { id: e.originalItem.id, serieId: e.originalItem.serieId });
          this.showEventDetails = true;
        } else {
          //throw error
        }
      } else {
        this.edittingEvent = e.originalItem;
        this.showEventDetails = true;
      }
    },
    addNewItem(date) {
      let forDate = date || new Date();
      let startDate = moment(this.getStartDate(forDate));
      let endDate = moment(this.getStartDate(forDate)).add(30, "minutes");
      this.edittingEvent = {
        id: null,
        startDate: startDate,
        endDate: endDate,
        title: "",
        classes: null,
        url: null,
      };
      this.showEventDetails = true;
    },
    getStartDate(forDate) {
      var now = new Date();
      now.setSeconds(0);
      now.setMinutes(Math.floor(now.getMinutes() / 30) * 30);
      now.setDate(forDate.getDate());
      now.setMonth(forDate.getMonth());
      now.setFullYear(forDate.getFullYear());
      return now;
    },
    setShowDate(d) {
      this.message = `Changing calendar view to ${d.toLocaleDateString()}`;
      this.showDate = d;
    },
    setSelection(dateRange) {
      this.selectionEnd = dateRange[1];
      this.selectionStart = dateRange[0];
    },
    finishSelection(dateRange) {
      this.setSelection(dateRange);
      this.message = `You selected: ${this.selectionStart.toLocaleDateString()} -${this.selectionEnd.toLocaleDateString()}`;
    },
    onDrop(item, date) {
      this.message = `You dropped ${item.id} on ${date.toLocaleDateString()}`;
      // Determine the delta between the old start date and the date chosen,
      // and apply that delta to both the start and end date to move the item.
      const eLength = (this as any).dayDiff(item.startDate, date);
      item.originalItem.startDate = (this as any).addDays(item.startDate, eLength);
      item.originalItem.endDate = (this as any).addDays(item.endDate, eLength);
    },
    handleEventDetailSave(updatedEvent, event) {
      this.isLoading = true;

      // recurrence event
      if (updatedEvent.recurrence && updatedEvent.recurrence.enabled === true) {
        if (!updatedEvent.serieId) {
          let serie = Object.assign({}, updatedEvent, { id: this.uuid() });
          this.series.push(serie);

          updatedEvent.serieId = serie.id;

          // remove original event
          for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].id === updatedEvent.id) {
              this.items.splice(i, 1);
              break;
            }
          }
        } else {
          // update serie
          for (var i = 0; i < this.series.length; i++) {
            if (this.series[i].id === updatedEvent.serieId) {
              this.series[i] = Object.assign(this.series[i], updatedEvent, { id: updatedEvent.serieId });
              break;
            }
          }

          // remove all serie events
          let j = 0;
          while (j < this.items.length) {
            if (this.items[j].serieId === updatedEvent.serieId) {
              this.items.splice(j, 1);
            } else {
              ++j;
            }
          }
        }

        // generate serie events
        var options = {
          currentDate: updatedEvent.recurrence.startDate,
          endDate: updatedEvent.recurrence.endDate,
          iterator: true,
        };

        var interval = parser.parseExpression(this.getCronExpression(updatedEvent.recurrence), options);
        while (true) {
          try {
            var obj = interval.next();

            let startDate = updatedEvent.useTimezone
              ? moment.tz(moment(obj.value._date).format("DD MM YYYY HH:mm:ss"), "DD MM YYYY HH:mm:ss", updatedEvent.timezoneAbbr).toDate()
              : moment(obj.value._date).toDate();
            let endDate = moment(startDate).add(updatedEvent.recurrence.duration, "minutes").toDate();
            let item = {
              id: this.uuid(),
              serieId: updatedEvent.serieId,
              title: updatedEvent.title,
              startDate: startDate,
              endDate: endDate,
            };

            this.items.push(item);
          } catch (e) {
            break;
          }
        }
      }

      // disable recurrence
      if (updatedEvent.serieId && (!updatedEvent.recurrence || updatedEvent.recurrence.enabled !== true)) {
        // remove serie
        for (var i = 0; i < this.series.length; i++) {
          if (this.series[i].id === updatedEvent.serieId) {
            this.series.splice(i, 1);
            break;
          }
        }

        // remove all serie events except self
        let j = 0;
        while (j < this.items.length) {
          if (this.items[j].serieId === updatedEvent.serieId && this.items[j].id !== updatedEvent.id) {
            this.items.splice(j, 1);
          } else {
            ++j;
          }
        }

        updatedEvent.serieId = null;
      }

      if (!updatedEvent.serieId) {
        if (updatedEvent.id) {
          for (var i = 0; i < this.items.length; i++) {
            let item = this.items[i];
            if (this.items[i].id === this.edittingEvent.id) {
              this.items[i] = Object.assign(this.items[i], updatedEvent);
              break;
            }
          }
        } else {
          updatedEvent.id = this.uuid();
          this.items.push(updatedEvent);
        }
      }

      let context = this;
      setTimeout(function () {
        context.isLoading = false;
        context.version = context.version + 1;
        context.showEventDetails = false;
      }, 100);
    },
    handleEventDetailDelete(event, updatedEvent, option) {
      this.isLoading = true;

      for (var i = 0; i < this.items.length; i++) {
        if (option === "serie" ? this.items[i].serieId === updatedEvent.serieId : this.items[i].id === updatedEvent.id) {
          this.items.splice(i, 1);
          i--;
        }
      }

      // remove the serie when there is no event related
      let events = this.items.filter((item) => item.serieId === updatedEvent.serieId);
      if (events.length === 0) {
        for (var i = 0; i < this.series.length; i++) {
          if (this.series[i].id === updatedEvent.serieId) {
            this.series.splice(i, 1);
            break;
          }
        }
      }

      let context = this;
      setTimeout(function () {
        context.isLoading = false;
        context.version = context.version + 1;
        context.showEventDetails = false;
      }, 100);
    },
    getCronExpression(recurrence) {
      let minute = 0;
      let hour = 0;
      if (recurrence.startTime) {
        let startTime = moment(recurrence.startTime, "HH:mm");
        hour = startTime.hour();
        minute = startTime.minute();
      }

      let weekday = "*";
      let monthday = "*";

      if (recurrence.timeframe === "weekly") {
        weekday = recurrence.weekly.length > 0 ? recurrence.weekly.join(",") : "*";
        monthday = "?";
      } else if (recurrence.timeframe === "daily" && recurrence.daily === "weekday") {
        weekday = "1-5";
        monthday = "?";
      }

      if (recurrence.timeframe === "monthly") {
        if (recurrence.monthly === "dayIncrements") {
          monthday = `${recurrence.dayIncrementStart}/${recurrence.dayIncrement}`;
        } else if (recurrence.monthly === "daySpecific") {
          monthday = recurrence.daySpecific.length > 0 ? recurrence.daySpecific.join(",") : "*";
        }
        weekday = "?";
      }

      let cron = `${minute} ${hour} ${monthday} * ${weekday}`;
      return cron;
    },
  },
});
